<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" @click="$router.push('/clients')" style="cursor: pointer">Solicitantes</li>
        <li class="breadcrumb-item active" aria-current="page" v-if="client != null && client.user.person_type == 1">{{client.user.fiscal.first_name}} {{client.user.fiscal.last_name_1}}</li>
        <li class="breadcrumb-item active" aria-current="page" v-else-if="client != null">{{client.user.fiscal.name}}</li>
      </ol>
    </nav>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12" v-if="client != null">
          <div class="row" style="padding-bottom: 10px">
            <div class="col-md-12">
              <div class="card">
                <div class="card-header">Solicitante | CID: {{client.id}} | UID: {{client.user.id}}</div>
                <div class="card-body">
                  <h3 v-if="client.user.person_type == 1">{{client.user.fiscal.first_name}} {{client.user.fiscal.last_name_1}}</h3>
                  <h3 v-else>{{client.user.fiscal.name}}</h3>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <nav class="nav nav-pills nav-fill">
                <button class="btn btn-light nav-item nav-link active" @click="option = 'perfil'" style="cursor:pointer">Perfil</button>
                <button class="btn btn-light nav-item nav-link active" @click="option = 'proyectos'" style="cursor:pointer">Proyectos</button>
                <button class="btn btn-light nav-item nav-link active" @click="option = 'referencias'" style="cursor:pointer">Referencias</button>
              </nav>
            </div>
          </div>
          <div class="row" v-if="option == 'perfil'">
            <div class="col-md-12">
              <div class="row" style="padding-bottom: 10px" v-if="client.user.person_type == 1">
                <div class="col-md-12">
                  <div class="card">
                    <div class="card-header"><strong>Generales</strong></div>
                    <div class="card-body">
                      <div class="row">
                        <div class="form-group col-md-3">
                          <label>Nombre</label>
                          <input type="text" :value="client.user.fiscal.first_name" class="form-control">
                        </div>
                        <div class="form-group col-md-3">
                          <label>Segundo nombre</label>
                          <input type="text" :value="client.user.fiscal.second_name" class="form-control">
                        </div>
                        <div class="form-group col-md-3">
                          <label>Primer apellido</label>
                          <input type="text" :value="client.user.fiscal.last_name_1" class="form-control">
                        </div>
                        <div class="form-group col-md-3">
                          <label>Segundo apellido</label>
                          <input type="text" :value="client.user.fiscal.last_name_2" class="form-control">
                        </div>
                        <div class="form-group col-md-3">
                          <label>País de Nacionalidad</label>
                          <select class="form-control">
                            <option disabled selected></option>
                            <option v-for="country in countries" :value="country.id" :selected="client.user.fiscal.address.country_id == country.id">{{country.name}}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" style="padding-bottom: 10px" v-if="client.user.person_type == 1">
                <div class="col-md-12">
                  <div class="card">
                    <div class="card-header"><strong>Identificación</strong></div>
                    <div class="card-body">
                      <div class="row">
                        <div class="form-group col-md-4">
                          <label>RFC</label>
                          <input type="text" :value="client.user.fiscal.rfc" class="form-control">
                        </div>
                        <div class="form-group col-md-4">
                          <label>Ocupación</label>
                          <select class="form-control">
                            <option disabled selected></option>
                            <option v-for="occupation in occupations"
                                    :selected="client.user.fiscal.personal_occupation_id == occupation.id"  class="form-control" :value="occupation.id"
                            >{{occupation.name}}</option>
                          </select>
                        </div>
                        <div class="form-group col-md-4">
                          <label>CURP</label>
                          <input type="text" :value="client.user.fiscal.curp" class="form-control">
                        </div>
                        <div class="form-group col-md-6">
                          <label>ID Oficial - Frente</label>
                          <iframe v-if="client.user.fiscal.official_id_front_file != null" :src="storage+'/perfil/idFront/'+client.user.fiscal.official_id_front_file"></iframe>
                        </div>
                        <div class="form-group col-md-6">
                          <label>ID Oficial - Posterior</label>
                          <iframe v-if="client.user.fiscal.official_id_back_file != null" :src="storage+'/perfil/idBack/'+client.user.fiscal.official_id_back_file"></iframe>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row" style="padding-bottom: 10px" v-if="(client.user.person_type == 1 || client.user.person_type == 0) && !isAddressForeign">
                <div class="col-md-12">
                  <div class="card">
                    <div class="card-header"><strong>Domicilio</strong></div>
                    <div class="card-body">
                      <div class="row">
                        <div class="form-group col-md-3">
                          <label>País de Nacionalidad</label>
                          <select class="form-control">
                            <option disabled selected></option>
                            <option v-for="country in countries" :value="country.id" :selected="client.user.fiscal.address.country_id == country.id">{{country.name}}</option>
                          </select>
                        </div>
                        <div class="form-group col-md-3">
                          <label>Calle</label>
                          <input type="text" :value="client.user.fiscal.address.street" class="form-control">
                        </div>
                        <div class="form-group col-md-3">
                          <label>No. Exterior</label>
                          <input type="text" :value="client.user.fiscal.address.ext_number" class="form-control">
                        </div>
                        <div class="form-group col-md-3">
                          <label>No. Interior</label>
                          <input type="text" :value="client.user.fiscal.address.int_number" class="form-control">
                        </div>
                        <div class="form-group col-md-3">
                          <label>Codigo Postal</label>
                          <input type="text" :value="client.user.fiscal.address.zipcode" class="form-control">
                        </div>
                        <div class="form-group col-md-3">
                          <label>Estado</label>
                          <select class="form-control">
                            <option disabled selected></option>
                            <option v-for="state in states" :value="state.id" :selected="client.user.fiscal.address.state_id == state.id">{{state.name}}</option>
                          </select>
                        </div>
                        <div class="form-group col-md-3">
                          <label>Municipio/Cuidad</label>
                          <select class="form-control">
                            <option disabled selected></option>
                            <option v-for="city in cities" :value="city.id" :selected="client.user.fiscal.address.city_id == city.id">{{city.name}}</option>
                          </select>
                        </div>
                        <div class="form-group col-md-3">
                          <label>Colonia</label>
                          <select class="form-control">
                            <option disabled selected></option>
                            <option v-for="neighborhood in neighborhoods" :value="neighborhood.id" :selected="client.user.fiscal.address.neighborhood_id == neighborhood.id">{{neighborhood.name}}</option>
                          </select>
                        </div>
                        <div class="form-group col-md-3">
                          <label>Teléfono</label>
                          <input type="text" :value="client.user.fiscal.phone" class="form-control">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" style="padding-bottom: 10px" v-if="(client.user.person_type == 1 || client.user.person_type == 0) && isAddressForeign">
                <div class="col-md-12">
                  <div class="card">
                    <div class="card-header"><strong>Domicilio (Foráneo)</strong></div>
                    <div class="card-body">
                      <div class="row">
                        <div class="form-group col-md-3">
                          <label>País de Nacionalidad</label>
                          <select class="form-control">
                            <option disabled selected></option>
                            <option v-for="country in countries" :value="country.id" :selected="client.user.fiscal.address.country_id == country.id">{{country.name}}</option>
                          </select>
                        </div>
                        <div class="form-group col-md-3">
                          <label>Calle</label>
                          <input type="text" :value="client.user.fiscal.address.street" class="form-control">
                        </div>
                        <div class="form-group col-md-3">
                          <label>No. Exterior</label>
                          <input type="text" :value="client.user.fiscal.address.ext_number" class="form-control">
                        </div>
                        <div class="form-group col-md-3">
                          <label>No. Interior</label>
                          <input type="text" :value="client.user.fiscal.address.int_number" class="form-control">
                        </div>
                        <div class="form-group col-md-3">
                          <label>Codigo Postal</label>
                          <input type="text" :value="client.user.fiscal.address.foreign_zipcode" class="form-control">
                        </div>
                        <div class="form-group col-md-3">
                          <label>Estado</label>
                          <input type="text" :value="client.user.fiscal.address.other_state" class="form-control">
                        </div>
                        <div class="form-group col-md-3">
                          <label>Municipio/Cuidad</label>
                          <input type="text" :value="client.user.fiscal.address.other_city" class="form-control">
                        </div>
                        <div class="form-group col-md-3">
                          <label>Colonia</label>
                          <input type="text" :value="client.user.fiscal.address.foreign_neighborhood" class="form-control">
                        </div>
                        <div class="form-group col-md-3">
                          <label>Teléfono</label>
                          <input type="text" :value="client.user.fiscal.phone" class="form-control">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row" style="padding-bottom: 10px" v-if="client.user.person_type == 0">
                <div class="col-md-12">
                  <div class="card" >
                    <div class="card-header"><strong>Empresa</strong></div>
                    <div class="card-body">
                      <div class="row">
                        <div class="form-group col-md-3">
                          <label>Nombre</label>
                          <input type="text" :value="client.user.fiscal.name" class="form-control">
                        </div>
                        <div class="form-group col-md-3">
                          <label>Teléfono</label>
                          <input type="text" :value="client.user.fiscal.phone" class="form-control">
                        </div>
                        <div class="form-group col-md-3">
                          <label>RFC</label>
                          <input type="text" :value="client.user.fiscal.rfc" class="form-control">
                        </div>
                        <div class="form-group col-md-3">
                          <label>Numero Firma</label>
                          <input type="text" :value="client.user.fiscal.e_firma" class="form-control">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" style="padding-bottom: 10px" v-if="client.user.person_type == 0">
                <div class="col-md-12">
                  <div class="card">
                    <div class="card-header"><strong>Representante Legal</strong></div>
                    <div class="card-body">
                      <div class="row">
                        <div class="form-group col-md-3">
                          <label>Nombre</label>
                          <input type="text" :value="client.user.fiscal.personal.first_name" class="form-control">
                        </div>
                        <div class="form-group col-md-3">
                          <label>Segundo nombre</label>
                          <input type="text" :value="client.user.fiscal.personal.second_name" class="form-control">
                        </div>
                        <div class="form-group col-md-3">
                          <label>Primer apellido</label>
                          <input type="text" :value="client.user.fiscal.personal.last_name_1" class="form-control">
                        </div>
                        <div class="form-group col-md-3">
                          <label>Segundo apellido</label>
                          <input type="text" :value="client.user.fiscal.personal.last_name_2" class="form-control">
                        </div>
                        <div class="form-group col-md-3">
                          <label>País de Nacionalidad</label>
                          <select class="form-control">
                            <option disabled selected></option>
                            <option v-for="country in countries" :value="country.id" :selected="client.user.fiscal.personal.address.country_id == country.id">{{country.name}}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" style="padding-bottom: 10px" v-if="client.user.person_type == 0">
                <div class="col-md-12">
                  <div class="card">
                    <div class="card-header"><strong>Identificación</strong></div>
                    <div class="card-body">
                      <div class="row">
                        <div class="form-group col-md-4">
                          <label>RFC</label>
                          <input type="text" :value="client.user.fiscal.personal.rfc" class="form-control">
                        </div>
                        <div class="form-group col-md-4">
                          <label>Ocupación</label>
                          <select class="form-control">
                            <option disabled selected></option>
                            <option v-for="occupation in occupations"
                                    :selected="client.user.fiscal.personal.personal_occupation_id == occupation.id"  class="form-control" :value="occupation.id"
                            >{{occupation.name}}</option>
                          </select>
                        </div>
                        <div class="form-group col-md-4">
                          <label>CURP</label>
                          <input type="text" :value="client.user.fiscal.personal.curp" class="form-control">
                        </div>
                        <div class="form-group col-md-6">
                          <label>ID Oficial - Frente</label>
                          <iframe v-if="client.user.fiscal.personal.official_id_front_file != null" :src="storage+'/perfil/idFront/'+client.user.fiscal.personal.official_id_front_file"></iframe>
                        </div>
                        <div class="form-group col-md-6">
                          <label>ID Oficial - Posterior</label>
                          <iframe v-if="client.user.fiscal.personal.official_id_back_file != null" :src="storage+'/perfil/idBack/'+client.user.fiscal.personal.official_id_back_file"></iframe>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" style="padding-bottom: 10px" v-if="client.user.person_type == 0">
                <div class="col-md-12">
                  <div class="card">
                    <div class="card-header"><strong>Domicilio</strong></div>
                    <div class="card-body">
                      <div class="row">
                        <div class="form-group col-md-3">
                          <label>Calle</label>
                          <input type="text" :value="client.user.fiscal.address.street" class="form-control">
                        </div>
                        <div class="form-group col-md-3">
                          <label>No. Exterior</label>
                          <input type="text" :value="client.user.fiscal.address.ext_number" class="form-control">
                        </div>
                        <div class="form-group col-md-3">
                          <label>No. Interior</label>
                          <input type="text" :value="client.user.fiscal.address.int_number" class="form-control">
                        </div>
                        <div class="form-group col-md-3">
                          <label>Colonia</label>
                          <input type="text" :value="client.user.fiscal.address.neighborhood" class="form-control">
                        </div>
                        <div class="form-group col-md-3">
                          <label>País de Nacionalidad</label>
                          <select class="form-control">
                            <option disabled selected></option>
                            <option v-for="country in countries" :value="country.id" :selected="client.user.fiscal.address.country_id == country.id">{{country.name}}</option>
                          </select>
                        </div>
                        <div class="form-group col-md-3">
                          <label>Estado</label>
                          <select class="form-control">
                            <option disabled selected></option>
                            <option v-for="state in states" :value="state.id" :selected="client.user.fiscal.address.state_id == state.id">{{state.name}}</option>
                          </select>
                        </div>
                        <div class="form-group col-md-3">
                          <label>Municipio/Cuidad</label>
                          <select class="form-control">
                            <option disabled selected></option>
                            <option v-for="city in cities" :value="city.id" :selected="client.user.fiscal.address.city_id == city.id">{{city.name}}</option>
                          </select>
                        </div>
                        <div class="form-group col-md-3">
                          <label>Codigo Postal</label>
                          <input type="text" :value="client.user.fiscal.address.zipcode" class="form-control">
                        </div>
                        <div class="form-group col-md-3">
                          <label>Teléfono</label>
                          <input type="text" :value="client.user.fiscal.phone" class="form-control">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row" v-if="option == 'proyectos'">
            <div class="col-md-12">
              <div class="card">
                <div class="card-header">Proyectos</div>
                <div class="card-body">
                  <table class="table table-hover table-bordered">
                    <thead class="thead-dark">
                    <tr>
                      <th class="text-center">Alias</th>
                      <th class="text-center">Proyecto</th>
                      <th class="text-center">Cobranza</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="project in projects">
                      <td style="text-align: center; font-size: 20px; font-weight: bold" v-if="project.alias !== ''">{{project.alias}}</td>
                      <td style="text-align: center; font-size: 20px; font-weight: bold" v-else>Sin Alias</td>
                      <td style="text-align: center" @click="$router.push('/project/'+project.id)"> <button class="btn btn-default"> Ir </button></td>
                      <td style="text-align: center" @click="$router.push('/cobranza')"> <button class="btn btn-default"> Ir </button> </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="row" v-if="option == 'referencias'">
            <div class="col-md-12">
              <tab-references variant="contact-reference"></tab-references>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">
  import TabReferences from "./projects/process-flow/tab-references";

  export default  {
    name: 'client',
    components: {TabReferences},
    props: ['client_id','storage'],
    mounted() {
      Vue.toasted.show('Cargando Solicitante ID '+this.$route.params.id+'...', { position: 'bottom-center', closeOnSwipe: false });
      axios.get( '/api/clients/'+this.$route.params.id).then((resolve) => {
        this.client = resolve.data.client
        this.projects = resolve.data.projects
        this.occupations = resolve.data.occupations
        this.countries = resolve.data.countries
        
        this.getAddressValues();
      }).then(response => {
        Vue.toasted.clear()
        Vue.toasted.show('¡¡ Solicitante cargado !!', { position: 'bottom-center', type:'success', closeOnSwipe: false, duration: 3000 })
      }).catch(error => {
        Vue.toasted.clear()
        Vue.toasted.show('¡ERROR! Algo salió mal...', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 3000})
      });
    },
    data() {
      return {
        client: null,
        countries: [],
        states: [],
        cities: [],
        projects: [],
        occupations: [],
        neighborhoods: [],
        option: 'perfil'
      }
    },
    methods: {
      async getAddressValues() {
        let result = await axios.get(`api/getAddressById/${this.fiscal.address_id}`);
        if(result) {
          result = result.data;
          this.states = [result.state];
          this.cities = [result.city];
          this.neighborhoods = result.neighborhoods;
          
          this.fiscal.address.state_id = result.neighborhoods[0].city.state_id;
          this.fiscal.address.city_id = result.neighborhoods[0].city_id;
          this.fiscal.address.neighborhood_id = result.address.neighborhood_id;
        }
      }
    },
    computed: {
      fiscal() {
        return this.client.user.fiscal;
      },
      isAddressForeign() {
        return this.fiscal.address.country_id != 700;
      }
    }
}
</script>

<style scoped lang="scss">
  .client-uve {

  }
</style>
